import { Box, Flex, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { RiSearch2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  const requests = useSelector((state) => state.videoRequests.requests);
  const count = useSelector((state) => state.videoRequests.count);

  const matchingCount = useMemo(() => {
    const list = Array.isArray(requests) ? requests : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return list.length;
    return list.filter((row) => {
      const videoTitle = String(row?.video?.title || "").toLowerCase();
      const studentName = String(row?.student?.name || "").toLowerCase();
      return videoTitle.includes(q) || studentName.includes(q);
    }).length;
  }, [requests, searchTerm]);

  const listLen = Array.isArray(requests) ? requests.length : 0;
  const totalFromStore = count !== "" && count != null ? count : listLen;
  const q = (searchTerm || "").trim().toLowerCase();
  const displayTotal = q ? matchingCount : totalFromStore;

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            Video view requests
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            Approve extra video access, open student details, or remove outdated requests.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            {q ? "Matching requests" : "Total requests"}: {displayTotal}
          </Text>
        </Box>
      </Flex>

      <Box mb={6} maxW="520px">
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(106, 30, 30, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder="Search by video title or student name…"
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="rgba(255,255,255,0.85)"
            pl={10}
            _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(106, 30, 30, 0.2)" }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Box>
    </Box>
  );
};

export default SearchBar;
